import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import Projects from "./components/pages/Projects";
import Designs from "./components/pages/Designs";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path='/portfolio' exact element={<Home />} />
          <Route path='/' exact element={<Home />} />
          <Route path='/projects' exact element={<Projects />} />
          <Route path='/designs' exact element={<Designs />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
